import {
    styled,
    List as UiList,
    Skeleton as UiSkeleton,
    Typography,
} from "@mui/material"

export const Header = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: theme.spacing(5),
}))

export const TitleContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
}))

type StyledLinkTextProps = {
    underline: boolean,
}
export const LinkText = styled(Typography)<StyledLinkTextProps>(({ underline }) => ({
    textDecoration: underline ? "underline" : "none",
}))

export const ButtonsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(3),
}))

export const ErrorTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))

export const TitleSkeleton = styled(UiSkeleton)(({ theme }) => ({
    height: 27,
    marginBottom: theme.spacing(5),
    transform: "scale(1)",
}))

export const List = styled(UiList)(() => ({
}))
